import { Contract } from "../../domain/model/contract";
import { Entry } from "../../domain/model/entry";
import { Customer } from "../../domain/model/customer";
import { Project } from "../../domain/model/project";
import { TCompanyWithProjectID } from "../../domain/repository/company_repository";

// client entry list
interface IGetAllEntriesByClientResponse {
  entries?: Entry[];
  customers?: Customer[];
  project?: Project;
  contracts?: Contract[];
}
class GetAllEntriesByClientResponse implements IGetAllEntriesByClientResponse {
  public entries: Entry[];
  public customers: Customer[];
  public project: Project;
  public contracts: Contract[];
}

// customer entry list
interface IGetEntryProjectsByCustomerResponse {
  projects?: Project[];
  companiesWithProjectID?: TCompanyWithProjectID[];
  projectCount?: number | Long;
}
class GetEntryProjectsByCustomerResponse
  implements IGetEntryProjectsByCustomerResponse
{
  public projects: Project[];
  public companiesWithProjectID: TCompanyWithProjectID[];
  public projectCount: number | Long;
  public contractIndex: { [key: string]: Contract | null };
}

export {
  // client entry list
  GetAllEntriesByClientResponse,
  // customer entry list
  GetEntryProjectsByCustomerResponse,
};



// WEBPACK FOOTER //
// ./src/presentation/response/entry_response.ts